import { newSvg } from 't-lib-ui/helpers';

const STROKE_PROPS = { stroke: 'currentColor', 'stroke-width': '1.5', fill: 'none' } as const;
const STROKE_ROUND = { ...STROKE_PROPS, 'stroke-linecap': 'round', 'stroke-linejoin': 'round' } as const;

export function createLockSvg(size: number): SVGElement {
  // Shapes are shifted up by 1.5 units within the 16-unit viewBox so the icon's
  // visual center aligns with the text middle (vertical-align: middle).
  return newSvg('svg', { width: size, height: size, viewBox: '0 0 16 16', fill: 'none',
    class: 'lockIcon', style: { verticalAlign: 'middle' } }, [
    newSvg('rect', { x: '3', y: '5.5', width: '10', height: '8', rx: '1.5', ...STROKE_PROPS }),
    newSvg('path', { d: 'M5.5 5.5V3.5a2.5 2.5 0 0 1 5 0v2', ...STROKE_PROPS, 'stroke-linecap': 'round' }),
  ]);
}

export function createHomeSvg(size: number): SVGElement {
  return newSvg('svg', { width: size, height: size, viewBox: '0 0 16 16', fill: 'none',
    style: { display: 'inline-block', verticalAlign: 'middle' } }, [
    newSvg('path', { d: 'M8 1.6 1 7.6h1.6v6.8h3.8V9.8h3.2v4.6h3.8V7.6H15L8 1.6Z', fill: 'currentColor' }),
  ]);
}

export function createArrowRightSvg(size: number): SVGElement {
  return newSvg('svg', { width: size, height: size, viewBox: '0 0 16 16', fill: 'none',
    stroke: 'currentColor', 'stroke-width': '1.5', 'stroke-linecap': 'round', 'stroke-linejoin': 'round',
    style: { display: 'inline-block', verticalAlign: 'middle' } }, [
    newSvg('line', { x1: '3', y1: '8', x2: '13', y2: '8' }),
    newSvg('polyline', { points: '9 4 13 8 9 12' }),
  ]);
}

export function createPlusSvg(size: number): SVGElement {
  return newSvg('svg', { width: size, height: size, viewBox: '0 0 24 24', fill: 'none',
    stroke: 'currentColor', 'stroke-width': '3', 'stroke-linecap': 'round', 'stroke-linejoin': 'round',
    style: { display: 'inline-block', verticalAlign: 'middle' } }, [
    newSvg('line', { x1: '12', y1: '5', x2: '12', y2: '19' }),
    newSvg('line', { x1: '5', y1: '12', x2: '19', y2: '12' }),
  ]);
}

/** Same unfold shape as ShowAllIcon.tsx: "reveal the posts hidden above and below". */
export function createShowAllSvg(size: number): SVGElement {
  return newSvg('svg', { width: size, height: size, viewBox: '0 0 16 16', fill: 'none',
    stroke: 'currentColor', 'stroke-width': '1.5', 'stroke-linecap': 'round', 'stroke-linejoin': 'round',
    style: { display: 'inline-block', verticalAlign: 'middle' } }, [
    newSvg('path', { d: 'M5 5l3-3 3 3' }),
    newSvg('path', { d: 'M3 8h10' }),
    newSvg('path', { d: 'M5 11l3 3 3-3' }),
  ]);
}

export function createCheckmarkSvg(size: number): SVGElement {
  return newSvg('svg', { width: size, height: size, viewBox: '0 0 16 16', fill: 'none',
    stroke: 'currentColor', 'stroke-width': '2', 'stroke-linecap': 'round', 'stroke-linejoin': 'round',
    style: { display: 'inline-block', verticalAlign: 'middle' } }, [
    newSvg('path', { d: 'M3 8.5l3.5 3.5L13 4' }),
  ]);
}

export function createCheckmarkCircleSvg(size: number): SVGElement {
  return newSvg('svg', { width: size, height: size, viewBox: '0 0 24 24', fill: 'none',
    stroke: 'currentColor', 'stroke-width': '2', 'stroke-linecap': 'round', 'stroke-linejoin': 'round',
    style: { display: 'inline-block', verticalAlign: 'middle' } }, [
    newSvg('circle', { cx: '12', cy: '12', r: '10' }),
    newSvg('path', { d: 'M9 12l2 2 4-4' }),
  ]);
}

export function createSpinnerSvg(): SVGElement {
  return newSvg('svg', { class: 'spinner spinning', width: '24', height: '24', viewBox: '0 0 24 24' },
    newSvg('path', { d: 'M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z' }));
}

export function createTrashSvg(size: number): SVGElement {
  return newSvg('svg', { width: size, height: size, viewBox: '0 0 24 24', fill: 'none',
    style: { display: 'inline-block', verticalAlign: 'middle' } }, [
    newSvg('path', { d: 'M4 7h16M9.5 7V4.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1V7', ...STROKE_ROUND }),
    newSvg('path', { d: 'M6 7l1 13h10l1-13M10 11v6M14 11v6', ...STROKE_ROUND }),
  ]);
}

export function createClockSvg(size: number): SVGElement {
  return newSvg('svg', { width: size, height: size, viewBox: '0 0 16 16', fill: 'none',
    style: { display: 'inline-block', verticalAlign: 'middle' } }, [
    newSvg('circle', { cx: '8', cy: '8', r: '7', ...STROKE_PROPS }),
    newSvg('path', { d: 'M8 4 L8 8 L11 10', ...STROKE_ROUND }),
  ]);
}

export function createShareSvg(size: number): SVGElement {
  const S = { stroke: 'currentColor', 'stroke-width': '1.3' } as const;
  const SR = { ...S, 'stroke-linecap': 'round', 'stroke-linejoin': 'round' } as const;
  const isApple = /Mac|iPhone|iPad|iPod/.test(navigator.platform || '') || /Macintosh|iPhone|iPad/.test(navigator.userAgent);

  const children: SVGElement[] = isApple ? [
    newSvg('path', { d: 'M4 7h-1.5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H12', ...SR }),
    newSvg('path', { d: 'M8 10V1.5M5 4.5L8 1.5l3 3', ...SR }),
  ] : [
    ...([[3, 8], [13, 3.5], [13, 12.5]] as const).map(([cx, cy]) =>
      newSvg('circle', { cx, cy, r: '2', ...S, fill: 'none' })),
    newSvg('line', { x1: '4.8', y1: '7', x2: '11.2', y2: '4.5', ...S }),
    newSvg('line', { x1: '4.8', y1: '9', x2: '11.2', y2: '11.5', ...S }),
  ];

  return newSvg('svg', { width: size, height: size, viewBox: '0 0 16 16', fill: 'none',
    style: { display: 'inline-block', verticalAlign: 'middle' } }, children);
}
